/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useLayoutEffect, useState } from 'react'
import { CircleArrowLeft } from '../../assets/icons/CircleArrowLeft'
import { CircleArrowRight } from '../../assets/icons/CircleArrowRight'
import { getMergedClassNames, getUniqueKey } from '../../utils/HTMLutils'
import { scrollSmooth } from '../../utils/ScrollUtils'
import IconButton from '../iconButton/IconButton'
import { TableProps } from '../table/Table'
import './TableWithOverflow.scss'
const rootClassName = 'component-table-with-overflow'

interface TableWithOverflowProps extends TableProps {
  showArrowControl?: boolean
}
function TableWithOverflow(props: TableWithOverflowProps) {
  const [id] = useState(`${getUniqueKey()}`)
  const [fakeId] = useState(`fake_table${getUniqueKey()}`)

  const attWidth = () => {
    const fake = document.querySelector(`#${fakeId}`) as HTMLElement
    const real = document.querySelector(
      `#${id} .${rootClassName}-table`
    ) as HTMLElement
    if (real && fake) {
      fake.style.width = `${real.getBoundingClientRect().width}px`
    }
  }

  const header = () => {
    document
      .querySelectorAll(
        `#${id} .${rootClassName}-table .${rootClassName}-header .${rootClassName}-cell`
      )
      .forEach((element: HTMLElement, index) => {
        const fakeElement = document.querySelector(
          `#${fakeId} thead tr th:nth-child(${index + 2})`
        ) as HTMLElement
        if (fakeElement) {
          element.style.minWidth = `${
            fakeElement.getBoundingClientRect().width
          }px`
          element.style.height = `${
            fakeElement.getBoundingClientRect().height
          }px`
        }
      })
  }

  const body = () => {
    document
      .querySelectorAll(
        `#${id} .${rootClassName}-table .${rootClassName}-body .${rootClassName}-cell`
      )
      .forEach((el: HTMLElement) => {
        const columnRef = el.getAttribute('columnref')
        const rowRef = el.getAttribute('rowref')
        if (columnRef && rowRef) {
          const fakeElement = document.querySelector(
            `#${fakeId} tbody tr:nth-child(${rowRef}) td:nth-child(${columnRef})`
          ) as HTMLElement
          if (fakeElement) {
            el.style.minWidth = `${fakeElement.getBoundingClientRect().width}px`
            el.style.height = `${fakeElement.getBoundingClientRect().height}px`
          }
        }
      })
  }

  const midWith = () => {
    const arrowControls = document.querySelector(
      `#${id} .${rootClassName}-arrow-control`
    ) as HTMLElement
    const mid = document.querySelector(
      `#${id} .${rootClassName}-table .${rootClassName}-mid`
    ) as HTMLElement
    if (!mid) return
    mid.classList.add('over')
    if (arrowControls) {
      arrowControls.style.display = 'flex'
    }
    const { clientWidth, scrollWidth } = mid
    if (
      clientWidth >= scrollWidth ||
      Array.from(mid.querySelectorAll(`.${rootClassName}-cell`)).some((it) => {
        return it.getBoundingClientRect().width > clientWidth
      })
    ) {
      mid.classList.remove('over')
      if (arrowControls) {
        arrowControls.style.display = 'none'
      }
    }
  }

  useLayoutEffect(() => {
    attWidth()
    header()
    body()
    midWith()
  }, [])

  useLayoutEffect(() => {
    const func = () => {
      attWidth()
      header()
      body()
      midWith()
    }
    window.addEventListener('resize', func)
    return () => {
      window.removeEventListener('resize', func)
    }
  }, [])

  useLayoutEffect(() => {
    const element = document.querySelector(
      `#${id} .${rootClassName}-table .${rootClassName}-mid`
    ) as HTMLElement
    let pos = { left: 0, x: 0 }
    let moving = false

    const mouseDownHandler = (evt: any) => {
      if (evt.button === 0 && element.scrollWidth > element.clientWidth) {
        moving = true
        pos = {
          left: element.scrollLeft,
          x: evt.clientX
        }
      }
    }

    const mouseMoveHandler = (evt: any) => {
      const dx = evt.clientX - pos.x

      // Scroll the element
      if (moving) {
        element.scrollLeft = pos.left - dx
      }
    }
    const mouseUpHandler = () => {
      moving = false
    }
    element.addEventListener('mousedown', mouseDownHandler)
    document.addEventListener('mousemove', mouseMoveHandler)
    document.addEventListener('mouseup', mouseUpHandler)
    return () => {
      element.removeEventListener('mousedown', mouseDownHandler)
      document.removeEventListener('mousemove', mouseMoveHandler)
      document.removeEventListener('mouseup', mouseUpHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <React.Fragment>
      <div id={id} className={rootClassName}>
        <table id={fakeId} className={`${rootClassName}-fake-table`}>
          <thead>
            <tr>
              <th />
              {props.columns && props.columns.length
                ? props.columns.map((column, columnIndex) => {
                    return (
                      <th
                        {...column.props}
                        key={column.key ? column.key : columnIndex}
                      >
                        {column.value}
                      </th>
                    )
                  })
                : undefined}
              <th />
            </tr>
          </thead>
          <tbody>
            <tr />
            {props.lines && props.lines.length
              ? props.lines.map((line: any, index) => {
                  const key = line.key ? line.key : index
                  delete line.key
                  const lineProps = line.props ? line.props : {}
                  delete line.props
                  return (
                    <tr key={key} {...lineProps}>
                      <td />
                      {Object.values(line).map((cell: any, valueIndex) => {
                        return (
                          <td
                            key={cell.key ? cell.key : valueIndex}
                            {...props.columns![valueIndex].props}
                            {...cell.props}
                          >
                            {cell}
                          </td>
                        )
                      })}
                      <td />
                    </tr>
                  )
                })
              : undefined}
          </tbody>
        </table>
        {props.upperHeader ? (
          <React.Fragment>
            <div
              className={getMergedClassNames([
                `${rootClassName}-upper-header`,
                props.upperHeader.active ? 'active' : ''
              ])}
            >
              {props.upperHeader.buttons && props.upperHeader.buttons.length
                ? props.upperHeader.buttons.map((btn, index) => {
                    return (
                      <button
                        id={btn.id || undefined}
                        key={index}
                        onClick={btn.onClick}
                        disabled={
                          !props.upperHeader?.active || btn.disabled || false
                        }
                      >
                        <span>{btn.icon}</span>
                        {btn.label}
                      </button>
                    )
                  })
                : undefined}
            </div>
          </React.Fragment>
        ) : undefined}
        <div className={`${rootClassName}-outer-table`}>
          <div
            className={getMergedClassNames([
              `${rootClassName}-table`,
              props.upperHeader ? 'has-upper-header' : ''
            ])}
          >
            <div className={`${rootClassName}-left`}>
              <div className={`${rootClassName}-header`}>
                {props.columns && props.columns.length
                  ? props.columns.slice(0, 2).map((column, index) => {
                      return (
                        <div
                          key={index}
                          {...column.props}
                          className={getMergedClassNames([
                            `${rootClassName}-cell`,
                            column.props && column.props.className
                              ? column.props.className
                              : ''
                          ])}
                          style={{ width: '50%' }}
                        >
                          {column.value}
                        </div>
                      )
                    })
                  : undefined}
              </div>
              <div className={`${rootClassName}-body`}>
                {props.lines && props.lines.length
                  ? props.lines.map((line, index) => {
                      return (
                        <div key={index} className={`${rootClassName}-row`}>
                          <div
                            className={`${rootClassName}-cell`}
                            //@ts-ignore
                            columnref={2}
                            rowref={index + 2}
                          >
                            {line[props.columns![0]?.key]}
                          </div>
                          <div
                            className={`${rootClassName}-cell`}
                            //@ts-ignore
                            columnref={3}
                            rowref={index + 2}
                          >
                            {line[props.columns![1]?.key]}
                          </div>
                        </div>
                      )
                    })
                  : undefined}
              </div>
            </div>
            <div className={`${rootClassName}-mid`}>
              <div className={`${rootClassName}-header`}>
                {props.columns && props.columns.length
                  ? props.columns
                      .map((column, index) => {
                        return (
                          <div
                            key={index}
                            {...column.props}
                            className={getMergedClassNames([
                              `${rootClassName}-cell`,
                              column.props && column.props.className
                                ? column.props.className
                                : ''
                            ])}
                          >
                            {column.value}
                          </div>
                        )
                      })
                      .slice(2, props.columns.length - 1)
                  : undefined}
              </div>
              <div className={`${rootClassName}-body`}>
                {props.lines && props.lines.length
                  ? props.lines.map((line, lineIndex) => {
                      return (
                        <div key={lineIndex} className={`${rootClassName}-row`}>
                          {props.columns && props.columns.length
                            ? Array.from(props.columns)
                                .map((column, index) => {
                                  return (
                                    <div
                                      //@ts-ignore
                                      columnref={index + 2}
                                      rowref={lineIndex + 2}
                                      key={index}
                                      className={`${rootClassName}-cell`}
                                    >
                                      {line[column.key]}
                                    </div>
                                  )
                                })
                                .slice(2, props.columns.length - 1)
                            : undefined}
                        </div>
                      )
                    })
                  : undefined}
              </div>
            </div>
            <div className={`${rootClassName}-right`}>
              <div className={`${rootClassName}-header`}>
                {props.columns && props.columns.length
                  ? props.columns
                      .map((column, index) => {
                        return (
                          <div
                            key={index}
                            {...column.props}
                            className={getMergedClassNames([
                              `${rootClassName}-cell`,
                              column.props && column.props.className
                                ? column.props.className
                                : ''
                            ])}
                          >
                            {column.value}
                          </div>
                        )
                      })
                      .slice(props.columns.length - 1, props.columns.length)
                  : undefined}
                {props.showArrowControl ? (
                  <div className={`${rootClassName}-arrow-control`}>
                    <IconButton
                      icon={<CircleArrowLeft />}
                      onClick={() => {
                        const mid = document.querySelector(
                          `#${id} .${rootClassName}-table .${rootClassName}-mid`
                        ) as HTMLElement
                        scrollSmooth({
                          element: mid,
                          top: 0,
                          left: mid.scrollLeft - 150,
                          behavior: 'smooth',
                          duration: 400
                        })
                      }}
                    />
                    <IconButton
                      icon={<CircleArrowRight />}
                      onClick={() => {
                        const mid = document.querySelector(
                          `#${id} .${rootClassName}-table .${rootClassName}-mid`
                        ) as HTMLElement
                        scrollSmooth({
                          element: mid,
                          top: 0,
                          left: mid.scrollLeft + 150,
                          behavior: 'smooth',
                          duration: 400
                        })
                      }}
                    />
                  </div>
                ) : undefined}
              </div>
              <div className={`${rootClassName}-body`}>
                {props.lines && props.lines.length
                  ? props.lines.map((line, lineIndex) => {
                      return (
                        <div key={lineIndex} className={`${rootClassName}-row`}>
                          {props.columns && props.columns.length
                            ? Array.from(props.columns)
                                .map((column, index) => {
                                  return (
                                    <div
                                      //@ts-ignore
                                      rowref={lineIndex + 2}
                                      columnref={index + 2}
                                      key={index}
                                      className={`${rootClassName}-cell`}
                                    >
                                      {line[column.key]}
                                    </div>
                                  )
                                })
                                .slice(
                                  props.columns.length - 1,
                                  props.columns.length
                                )
                            : undefined}
                        </div>
                      )
                    })
                  : undefined}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

TableWithOverflow.defaultProps = {
  showArrowControl: true
}

export default memo(TableWithOverflow)
